"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUrl = exports.getUrlWithRegCodeParamMovedToStartOfQueryString = exports.parseUrlDataDefaultObject = void 0;
var tslib_1 = require("tslib");
var query_string_1 = require("query-string");
exports.parseUrlDataDefaultObject = {
    activationCode: "",
    callbackUrl: "",
    clientId: "",
    countryCode: "",
    mvpdCode: "",
    mvpdName: "",
    platform: "",
};
var getValidParseUrlData = function (parseUrlData) {
    return tslib_1.__assign(tslib_1.__assign({}, exports.parseUrlDataDefaultObject), parseUrlData);
};
var getUrlData = function (parseUrlData) {
    var _a = getValidParseUrlData(parseUrlData), authorizationCode = _a.authorizationCode, queryWithoutAuthCode = tslib_1.__rest(_a, ["authorizationCode"]);
    var queryWithAuthCode = tslib_1.__assign(tslib_1.__assign({}, queryWithoutAuthCode), { authorizationCode: authorizationCode });
    var hasAuthorizationCodeValue = Boolean(authorizationCode);
    return hasAuthorizationCodeValue ? queryWithAuthCode : queryWithoutAuthCode;
};
/**
 * window.location.href on IE invalidly encodes &reg from query params to ®. As a workaround set &reg_code param as
 * a first query param to make it starting with ? (?reg_code)
 * https://stackoverflow.com/questions/15532252/why-is-reg-being-rendered-as-without-the-bounding-semicolon
 */
var getUrlWithRegCodeParamMovedToStartOfQueryString = function (url) {
    var parsedUrl = (0, query_string_1.parseUrl)(url);
    var sortedQuery = (0, query_string_1.stringify)(parsedUrl.query, {
        sort: function (itemLeft) {
            return itemLeft === "reg_code" ? -1 : 1;
        },
    });
    return "".concat(parsedUrl.url, "?").concat(sortedQuery);
};
exports.getUrlWithRegCodeParamMovedToStartOfQueryString = getUrlWithRegCodeParamMovedToStartOfQueryString;
/**
 * This method reverts invalid encoding from IE.
 * https://stackoverflow.com/questions/15532252/why-is-reg-being-rendered-as-without-the-bounding-semicolon
 */
var getUrlWithRevertIEEncodingOfRegValue = function (url) {
    return url.replace("®", "&reg");
};
var getEncodedAuthSuiteData = function (data) {
    var authSuiteDataString = JSON.stringify(data);
    var encodedAuthSuiteData = btoa(authSuiteDataString);
    return encodeURIComponent(encodedAuthSuiteData);
};
var parseUrl = function (parseUrlData) {
    var _a = getUrlData(parseUrlData), clientId = _a.clientId, countryCode = _a.countryCode, callbackUrl = _a.callbackUrl, validParseUrlData = tslib_1.__rest(_a, ["clientId", "countryCode", "callbackUrl"]);
    var queryParams = tslib_1.__assign(tslib_1.__assign({}, validParseUrlData), { authSuiteData: getEncodedAuthSuiteData({ clientId: clientId, countryCode: countryCode }) });
    var decodedUrl = decodeURIComponent(callbackUrl);
    var parsedUrl = (0, query_string_1.parseUrl)(decodedUrl);
    var urlString = "".concat(parsedUrl.url, "?").concat((0, query_string_1.stringify)(queryParams));
    var encodedUrl = encodeURIComponent(urlString);
    return getUrlWithRevertIEEncodingOfRegValue(encodedUrl);
};
exports.parseUrl = parseUrl;
